

export const index = 4;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/docs/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/4.Ck8wLqta.js","_app/immutable/chunks/mtF927Wn.js","_app/immutable/chunks/C8t-7i39.js","_app/immutable/chunks/IHki7fMi.js"];
export const stylesheets = ["_app/immutable/assets/4.QQ4MeSSw.css"];
export const fonts = [];
